import React, { useEffect, useState } from "react";
import CustomizeServices from "../based/services/CustomizeServices";
import { ThumbnailArtworkUrl } from "./ThumbnailArtworkUrl";

function CartItem({ groupDesignId, itemWidth = 100 }) {
    const [data, setData] = useState({});
    const { printOrderProducts, designExtends } = data;
    const [artworkData, setArtworkData] = useState([]);

    useEffect(() => {
        if (groupDesignId) getDesignModel(groupDesignId);
    }, [groupDesignId]);

    useEffect(() => {
        let artworkData = _getArtworkData();
        setArtworkData(artworkData);
    }, [printOrderProducts]);

    const getDesignModel = async (groupDesignId) => {
        let [err, data] = await CustomizeServices.GetDesignDetailByGroupDesignIdAnonymous(groupDesignId);
        if (!err && data) {
            setData(data);
        }
    };

    const _getArtworkData = () => {
        if (printOrderProducts) {
            let res = [];
            printOrderProducts.map((item, idx) => {
                let colorModel = item.colorModel;
                colorModel.map((element, index) => {
                    for (const designExtend of designExtends) {
                        let selectedOrderImage = element.printOrderImages && element.printOrderImages.find((img) => designExtend.artworkType == img.artworkType);
                        for (var ele of designExtend.elements) {
                            let text = ele.elementText;
                            if (text) {
                                ele.fontText = text.fontText;
                                ele.fontFamily = text.fontFamily;
                                ele.fontColor = text.fontColor;
                                ele.fontSize = text.fontSize;
                                ele.fontWeight = text.fontWeight;
                            }
                        }
                        res.push({
                            selectedOrderImage,
                            designExtend,
                        });
                    }
                });
            });
            return res;
        }

        return [];
    };

    if (!artworkData || artworkData.length === 0) return null;
    return (
        <div className="list-image">
            {artworkData.map((item, idx) => {
                return (
                    <ThumbnailArtworkUrl
                        url={item.selectedOrderImage.url}
                        width={itemWidth}
                        height={itemWidth}
                        dimensionWidth={1000}
                        boundaryX={item.designExtend.boundaryX}
                        boundaryY={item.designExtend.boundaryY}
                        boundaryWidth={item.designExtend.boundaryWidth}
                        boundaryHeight={item.designExtend.boundaryHeight}
                        elements={item.designExtend.elements}
                        hideBackground={false}
                        designExtend={item.designExtend}
                    />
                );
            })}
        </div>
    );
}

export default CartItem;
